import PartyCircles from "@/components/party-circles";
import TicketPackage from "@/components/ticket-package";
import ContentBlock from "@/components/content-block";
import DateToFormat from "@/components/date-to-format";
import HotelSignupView from "@/views/hotel-signup";
import dynamicLocalization from "@/mixins/dynamic-localization";
import TICKETS from "@/data/tickets.yml";

const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);
const NEXT_PARTY_DATE = JSON.parse(process.env.VUE_APP_NEXT_PARTY_DATE);
const CURRENT_PARTY_DATE = JSON.parse(process.env.VUE_APP_PARTY_DATE);

const ticketSaleStart = new Date(
  Date.UTC(
    TICKET_SALE_START.year,
    TICKET_SALE_START.month - 1,
    TICKET_SALE_START.day,
    TICKET_SALE_START.hour + TICKET_SALE_START.utcOffset,
    0
  )
);

const nextParty = new Date(
  Date.UTC(
    NEXT_PARTY_DATE.year,
    NEXT_PARTY_DATE.month - 1,
    NEXT_PARTY_DATE.day,
    (NEXT_PARTY_DATE.hour || 0) + (NEXT_PARTY_DATE.utcOffset || 0),
    0
  )
);

const currentParty = new Date(
  Date.UTC(
    CURRENT_PARTY_DATE.year,
    CURRENT_PARTY_DATE.month - 1,
    CURRENT_PARTY_DATE.day,
    (CURRENT_PARTY_DATE.hour || 0) + (CURRENT_PARTY_DATE.utcOffset || 0),
    0
  )
);

export default {
  mixins: [dynamicLocalization],
  components: {
    PartyCircles,
    TicketPackage,
    ContentBlock,
    DateToFormat,
    HotelSignupView,
  },
  data() {
    const now = new Date();
    const ticketSaleStartDateKnown = ticketSaleStart
      ? ticketSaleStart > now
      : false;

    return {
      authenticated: false,
      ticketSaleStart,
      nextParty,
      currentParty,
      now,
      TICKETS,
    };
  },
  computed: {
    ticketSaleActive() {
      return this.ticketSaleStart - this.now < 0;
    },
  },
  methods: {
    authenticate() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      this.authenticated = credentials && true;
    },
  },
  created() {
    window.setInterval(() => {
      this.now = new Date();
    }, 300);
  },
  mounted() {
    this.authenticate();
  },
};
